module.exports = __webpack_public_path__ + "static/media/endosee-accessories-thumb.d9254b8d.jpg";